// Инициализация карточки планировки

import initActions from './actions';
import initTabs from './initTabs';
import {initRangeOne} from './initRangeOne';
import {newCard} from './newCard';

/**
 * Инициализация карточки планировки
 */
function main(): void
{
	initActions();
	newCard();
	initRangeOne();
	initTabs();
}

/**
 * Module
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/Card/index.ts